import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { formatDateTime } from '../../utils/formatDateTime';

const SEVERITY_STYLES = {
  CRITICAL: 'bg-red-100 text-red-700 border-red-200',
  HIGH: 'bg-orange-100 text-orange-700 border-orange-200',
  MEDIUM: 'bg-amber-100 text-amber-700 border-amber-200',
  LOW: 'bg-blue-100 text-blue-700 border-blue-200',
};

const ANOMALY_TYPE_LABELS = {
  alert_spike: 'Alert Spike',
  compliance_drop: 'Compliance Drop',
  occupancy_anomaly: 'Occupancy Anomaly',
};

export default function AnomalyTimeline({ anomalies = [], onAcknowledge }) {
  if (anomalies.length === 0) {
    return (
      <div className="glass p-6 text-center">
        <CheckCircleIcon className="w-12 h-12 text-emerald-400 mx-auto mb-2" />
        <p className="text-sm text-slate-500">No active anomalies detected</p>
      </div>
    );
  }

  return (
    <div className="glass p-4">
      <h3 className="text-sm font-semibold text-slate-700 mb-4">Anomaly Timeline</h3>
      <div className="space-y-3 max-h-[400px] overflow-y-auto">
        {anomalies.map((anomaly) => {
          const styles = SEVERITY_STYLES[anomaly.severity] || SEVERITY_STYLES.MEDIUM;
          return (
            <div key={anomaly.id} className={`flex items-start gap-3 p-3 rounded-lg border ${styles}`}>
              <ExclamationTriangleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs font-bold uppercase">
                    {ANOMALY_TYPE_LABELS[anomaly.anomalyType] || anomaly.anomalyType}
                  </span>
                  <span className="text-xs font-semibold px-1.5 py-0.5 rounded bg-white/50">
                    {anomaly.severity}
                  </span>
                </div>
                <p className="text-xs mt-1 opacity-80">
                  {anomaly.description || `Observed: ${anomaly.observedValue}, Expected: ${anomaly.expectedValue}`}
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[10px] opacity-60">
                    {formatDateTime(anomaly.detectedAt)}
                  </span>
                  {anomaly.status === 'active' && onAcknowledge && (
                    <button
                      onClick={() => onAcknowledge(anomaly.id)}
                      className="text-[10px] font-semibold px-2 py-0.5 rounded bg-white/60 hover:bg-white/80 transition-colors"
                    >
                      Acknowledge
                    </button>
                  )}
                  {anomaly.status === 'acknowledged' && (
                    <span className="text-[10px] opacity-60">Acknowledged</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
